/*
  Kothari Sons - mega menu hover behaviour.
  Progressive enhancement on top of Dawn's <header-menu> (click / keyboard still work exactly as before).
  Only active on desktop with a real mouse; touch devices keep tap-to-open.
*/
(function () {
  var OPEN_DELAY = 90;   /* ms - avoids flicker when the pointer just passes over */
  var CLOSE_DELAY = 320; /* ms - lets the pointer cross the small gap between the nav bar and the panel */
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function init() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!menus.length) return;

    menus.forEach(function (menu) {
      var details = menu.querySelector('details.ks-mega');
      if (!details) return;
      var summary = details.querySelector('summary');
      var openTimer, closeTimer;

      function closeMenu(m) {
        if (typeof m.close === 'function') m.close();
        else {
          var d = m.querySelector('details');
          if (d) d.removeAttribute('open');
        }
      }

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          menus.forEach(function (other) { if (other !== menu) closeMenu(other); });
          if (!details.open) {
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
          }
        }, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeMenu(menu); }, CLOSE_DELAY);
      });

      /* Mouse click on the label goes to the category page (as on most fashion sites).
         Keyboard activation (event.detail === 0) still just toggles the panel. */
      summary.addEventListener('click', function (e) {
        if (!mq.matches || e.detail === 0) return;
        var url = summary.getAttribute('data-ks-url');
        if (url && url !== '#') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
